module.exports = __webpack_public_path__ + "img/businesscustomer.53b06193.png";